export enum VatPayerOption{
 Y = 1,
 N = 2
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/vat_payer_option.enum.ts